module.exports = __webpack_public_path__ + "static/media/banner-aam.5e9d504b.png";